import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["startTime", "endTime"]

  updateEndTime() {
    if (this.startTimeTarget.value) {
      const startTime = new Date(this.startTimeTarget.value)
      const endTime = new Date(startTime.getTime() + (1.5 * 60 * 60 * 1000)) // Add 1.5 hours
      this.endTimeTarget.value = endTime.toISOString()
    }
  }
}